import jsCookie from 'js-cookie';

function removeUserToken() {
  jsCookie.remove('userToken');
}

export { removeUserToken };
